"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _formatter = _interopRequireDefault(require("../../../utils/formatter"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _CardInput = _interopRequireDefault(require("../../CardInput"));

var _Base = require("../../Base");

var _AnimateHeight = _interopRequireDefault(require("../../AnimateHeight"));

var _cardholder = _interopRequireDefault(require("../cardholder"));

var _errorWrapper = _interopRequireDefault(require("../style/manual/errorWrapper"));

var _Input = _interopRequireDefault(require("../../Input"));

var _CvvInput = _interopRequireDefault(require("../../CvvInput"));

var _hint = _interopRequireDefault(require("../hint"));

var _InfoItalic = _interopRequireDefault(require("@p24/icons/InfoItalic"));

var _debitContent = _interopRequireDefault(require("../style/manual/debitContent"));

var _cvvExpireWrapper = _interopRequireDefault(require("../style/manual/cvvExpireWrapper"));

var _expire = _interopRequireDefault(require("../style/manual/expire"));

var _cvv = _interopRequireDefault(require("../style/manual/cvv"));

var _hintContainer = _interopRequireDefault(require("../style/manual/hintContainer"));

var _PropTypes$shape, _PropTypes$shape2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cvvDefaultProps = {
  label: 'DEBIT_SOURCE_WALLET_LABEL_CVV',
  floating: false
};
var numberDefaultProps = {
  label: 'DEBIT_SOURCE_CARD_LABEL_NUMBER',
  type: 'tel',
  autoComplete: 'cc-number',
  maxLength: 19
};
var expireDefaultProps = {
  label: 'DEBIT_SOURCE_CARD_LABEL_EXPIRE',
  placeholder: '01 / 20',
  maxLength: 7,
  autoComplete: 'cc-exp',
  floating: false,
  type: 'tel'
};

var expireFormat = function expireFormat(value) {
  return (0, _formatter["default"])(value, '{{dd}} / {{dd}}');
};

var Manual = function Manual(_ref) {
  var manual = _ref.manual,
      value = _ref.value,
      cvvHint = _ref.cvvHint,
      error = _ref.error,
      debit = _ref.debit,
      disabled = _ref.disabled,
      attribute = _ref.attribute,
      cardholder = _ref.cardholder,
      theme = _ref.theme,
      onChange = _ref.onChange;
  var cvv = (0, _react.useRef)(null);
  var expire = (0, _react.useRef)(null);
  var firstName = (0, _react.useRef)(null);

  var _useMemo = (0, _react.useMemo)(function () {
    var _manual$number, _manual$expire, _manual$cvv;

    return [_objectSpread({}, cvvDefaultProps, {
      label: _l10n["default"].t(cvvDefaultProps.label)
    }, manual === null || manual === void 0 ? void 0 : manual.cvv, {
      disabled: disabled
    }), _objectSpread({}, expireDefaultProps, {
      label: _l10n["default"].t(expireDefaultProps.label)
    }, manual === null || manual === void 0 ? void 0 : manual.expire, {
      disabled: disabled
    }), _objectSpread({}, numberDefaultProps, {
      label: _l10n["default"].t(numberDefaultProps.label)
    }, manual === null || manual === void 0 ? void 0 : manual.number, {
      disabled: disabled
    }), _objectSpread({}, manual === null || manual === void 0 ? void 0 : (_manual$number = manual.number) === null || _manual$number === void 0 ? void 0 : _manual$number.style, {
      width: '100%'
    }), _objectSpread({}, manual === null || manual === void 0 ? void 0 : (_manual$expire = manual.expire) === null || _manual$expire === void 0 ? void 0 : _manual$expire.style, {
      width: '100%'
    }), _objectSpread({}, manual === null || manual === void 0 ? void 0 : (_manual$cvv = manual.cvv) === null || _manual$cvv === void 0 ? void 0 : _manual$cvv.style, {
      width: '100%'
    })];
  }, [manual, disabled]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 6),
      cvvProps = _useMemo2[0],
      expireProps = _useMemo2[1],
      numberProps = _useMemo2[2],
      numberStyle = _useMemo2[3],
      expireStyle = _useMemo2[4],
      cvvStyle = _useMemo2[5];

  var handleChange = (0, _react.useCallback)(function (name, newValue) {
    if (typeof onChange === 'function') {
      var _objectSpread2;

      onChange(_objectSpread((_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_CVV, null), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_EXP, null), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_NUMBER, null), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_LAST_NAME, cardholder ? null : undefined), (0, _defineProperty2["default"])(_objectSpread2, _constants.ATTR_FIRST_NAME, cardholder ? null : undefined), _objectSpread2), value, (0, _defineProperty2["default"])({
        source: _constants.SOURCE_MANUAL
      }, name, newValue)));
    }
  }, [onChange, cardholder, value]);
  var onNumberChange = (0, _react.useCallback)(function (e) {
    return handleChange(_constants.ATTR_NUMBER, e.target.value.replace(/\D/gi, ''));
  }, [value]);
  var onExpireChange = (0, _react.useCallback)(function (e) {
    return handleChange(_constants.ATTR_EXP, e.target.value.replace(/\D/gi, '').substr(0, 4));
  }, [value]);
  var onCvvChange = (0, _react.useCallback)(function (e) {
    return handleChange(_constants.ATTR_CVV, e.target.value);
  }, [value]);
  var onFirstNameChange = (0, _react.useCallback)(function (value) {
    return handleChange(_constants.ATTR_FIRST_NAME, value);
  }, [value]);
  var onLastNameChange = (0, _react.useCallback)(function (value) {
    return handleChange(_constants.ATTR_LAST_NAME, value);
  }, [value]);
  (0, _react.useLayoutEffect)(function () {
    var _value$ATTR_NUMBER;

    if (value && ((_value$ATTR_NUMBER = value[_constants.ATTR_NUMBER]) === null || _value$ATTR_NUMBER === void 0 ? void 0 : _value$ATTR_NUMBER.length) === 16 && expire.current) {
      setTimeout(function () {
        return expire.current.focus();
      }, 0);
    }
  }, [value && value[_constants.ATTR_NUMBER]]);
  (0, _react.useLayoutEffect)(function () {
    var _value$ATTR_EXP;

    if (value && ((_value$ATTR_EXP = value[_constants.ATTR_EXP]) === null || _value$ATTR_EXP === void 0 ? void 0 : _value$ATTR_EXP.length) === 4 && cvv.current) {
      setTimeout(function () {
        return cvv.current.focus();
      }, 0);
    }
  }, [value && value[_constants.ATTR_EXP]]);
  (0, _react.useLayoutEffect)(function () {
    var _value$ATTR_CVV;

    if (cardholder && value && ((_value$ATTR_CVV = value[_constants.ATTR_CVV]) === null || _value$ATTR_CVV === void 0 ? void 0 : _value$ATTR_CVV.length) === 3) {
      setTimeout(function () {
        return firstName.current.focus();
      }, 0);
    }
  }, [cardholder, value && value[_constants.ATTR_CVV]]);
  (0, _react.useEffect)(function () {
    if (!cardholder) {
      handleChange(_constants.ATTR_FIRST_NAME, undefined);
      handleChange(_constants.ATTR_LAST_NAME, undefined);
    }
  }, [cardholder]);
  return _react["default"].createElement("div", null, _react["default"].createElement("div", null, _react["default"].createElement(_CardInput["default"], (0, _extends2["default"])({}, numberProps, {
    onChange: onNumberChange,
    value: value && value[_constants.ATTR_NUMBER],
    error: !!(error && error[_constants.ATTR_NUMBER]),
    attribute: _constants.ATTR_NUMBER + attribute,
    style: numberStyle
  })), _react["default"].createElement(_errorWrapper["default"], null, _react["default"].createElement(_Base.FieldError, {
    error: error === null || error === void 0 ? void 0 : error.number
  }))), debit ? _react["default"].createElement(_debitContent["default"], {
    theme: theme
  }, _react["default"].createElement(_cvvExpireWrapper["default"], null, _react["default"].createElement(_expire["default"], {
    theme: theme
  }, _react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, expireProps, {
    value: expireFormat(value && value[_constants.ATTR_EXP]),
    onChange: onExpireChange,
    error: !!(error && error[_constants.ATTR_EXP]),
    attribute: _constants.ATTR_EXP + attribute,
    ref: expire,
    style: expireStyle
  }))), _react["default"].createElement(_cvv["default"], {
    theme: theme
  }, _react["default"].createElement(_CvvInput["default"], (0, _extends2["default"])({}, cvvProps, {
    value: value && value[_constants.ATTR_CVV],
    onChange: onCvvChange,
    error: !!(error && error[_constants.ATTR_CVV]),
    attribute: _constants.ATTR_CVV + attribute,
    ref: cvv,
    style: cvvStyle
  })), cvvHint ? _react["default"].createElement(_hint["default"], (0, _extends2["default"])({}, cvvHint, {
    theme: theme
  }), _react["default"].createElement(_hintContainer["default"], {
    theme: theme
  }, _react["default"].createElement(_InfoItalic["default"], null))) : null)), _react["default"].createElement(_errorWrapper["default"], null, _react["default"].createElement(_Base.FieldError, {
    error: error && error[_constants.ATTR_EXP]
  }), _react["default"].createElement(_Base.FieldError, {
    error: error && error[_constants.ATTR_CVV]
  }))) : null, _react["default"].createElement(_AnimateHeight["default"], {
    open: cardholder
  }, _react["default"].createElement(_cardholder["default"], {
    theme: theme,
    disabled: disabled,
    firstName: _objectSpread({}, manual === null || manual === void 0 ? void 0 : manual.firstName, {
      value: value && value[_constants.ATTR_FIRST_NAME],
      onChange: onFirstNameChange,
      attribute: _constants.ATTR_FIRST_NAME + attribute,
      elementRef: firstName,
      error: error === null || error === void 0 ? void 0 : error.firstName
    }),
    lastName: _objectSpread({}, manual === null || manual === void 0 ? void 0 : manual.lastName, {
      value: value && value[_constants.ATTR_LAST_NAME],
      onChange: onLastNameChange,
      attribute: _constants.ATTR_LAST_NAME + attribute,
      error: error === null || error === void 0 ? void 0 : error.lastName
    })
  })));
};

Manual.propTypes = {
  manual: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  cardholder: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  debit: _propTypes["default"].bool,
  error: _propTypes["default"].shape((_PropTypes$shape = {}, (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_CARD_ID, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_NUMBER, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_EXP, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_LAST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape, _constants.ATTR_FIRST_NAME, _propTypes["default"].string), _PropTypes$shape)),
  value: _propTypes["default"].shape((_PropTypes$shape2 = {}, (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_CARD_ID, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_NUMBER, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_EXP, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_LAST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_FIRST_NAME, _propTypes["default"].string), (0, _defineProperty2["default"])(_PropTypes$shape2, _constants.ATTR_CVV, _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])), _PropTypes$shape2)),
  cvvHint: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object])
};
var _default = Manual;
exports["default"] = _default;